// extracted by mini-css-extract-plugin
export default {"form-disabled":"ResaleDetails_form-disabled__JTL2t"};